import { Injectable } from '@angular/core';
import { HistoryItemResponse } from './models/history-item.response';
import { HistoryItemStats } from './models/history-item-stats.model';

@Injectable({
  providedIn: 'root',
})
export class HistoryFactory {
  buildHistoryItemStats(responseItem: HistoryItemResponse): HistoryItemStats {
    return {
      ...responseItem,
      loanStart: responseItem.loanStart ? new Date(responseItem.loanStart) : null,
      loanEnd: responseItem.loanEnd ? new Date(responseItem.loanEnd) : null,
      stats: {
        ...responseItem.stats,
        firstAccess: new Date(responseItem.stats.firstAccess),
        lastAccess: new Date(responseItem.stats.lastAccess),
      }
    };
  }
}
